import { subDays, subHours } from 'date-fns'
import css from './rangePicker.module.css'
import { useState } from 'react'

interface IProps {
  startDate: Date
  onChange?: (date: Date | [Date, Date]) => void
}
const default_ranges = ['24 часа', '7 дней', '30 дней', '365 дней', 'Все время']
const calculateRange = (baseDate: Date, range: string): [Date, Date] => {
  const rangesMap: Record<string, [Date, Date]> = {
    '24 часа': [subHours(baseDate, -24), baseDate],
    '7 дней': [subDays(baseDate, -7), baseDate],
    '30 дней': [subDays(baseDate, -30), baseDate],
    '365 дней': [subDays(baseDate, -365), baseDate],
    'Все время': [new Date(0), new Date()],
  }

  return rangesMap[range] || [baseDate, baseDate]
}

const RangePicker = ({ startDate, onChange }: IProps) => {
  const [selectedRange, setSelectedRange] = useState('24 часа')

  const handleRangeSelect = (range: string) => {
    const baseDate = startDate || new Date()
    let [start, end] = calculateRange(baseDate, range)
    if (start > end) {
      ;[start, end] = [end, start]
    }
    setSelectedRange(range)
    onChange?.([start, end])
  }

  return (
    <div className={css.rangeColumn}>
      {default_ranges.map((rangeItem, index) => (
        <div
          key={rangeItem + index}
          className={`${css.rangeOption} ${rangeItem === selectedRange ? css.selectRangeOption : ''}`}
          onClick={() => handleRangeSelect(rangeItem)}
        >
          {rangeItem}
        </div>
      ))}
    </div>
  )
}

export default RangePicker
